// extracted by mini-css-extract-plugin
export default {"starterScreen":"ip","starterImage":"jp","already":"kp","btnContainer":"lp","starterImageMobile":"mp","starterTextContainWrapper":"np","controlX":"op","attrWrapper":"pp","logoWrapper":"qp","starterTextContain":"rp","starterHeader":"sp","starterBtn":"tp","starterSecondaryBtn":"up","starterBanner":"vp","logoWrapperMob":"wp","mobileBtnContainer":"xp"};
    if(module.hot) {
      // 1743628922149
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  